import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";

export const Field = ({ id, label, error, required, children, className = "" }) => (
  <div className={className}>
    <label htmlFor={id} className="mb-2 block text-xs font-semibold uppercase tracking-[0.16em] text-[#4A5D75]">
      {label}{required && <span className="text-[#A27D17]"> *</span>}
    </label>
    {children}
    {error && <p className="mt-2 text-sm text-[#B42318]" data-testid={`${id}-error`} role="alert">{error}</p>}
  </div>
);

export const inputCls = (err, dark = false) =>
  `w-full border-0 border-b bg-transparent px-0 py-3 text-base outline-none transition-colors duration-300 placeholder:text-[#7D8FA6] focus:ring-0 ${
    dark ? "text-white border-white/30 focus:border-[#C59B27] placeholder:text-[#9FB1C6]" : "text-[#0F172A] border-[#8EA3BC]/60 focus:border-[#1E3A5F]"
  } ${err ? "!border-[#B42318]" : ""}`;

export const Success = ({ title, body, refLabel, refId, again, onAgain, dark = false, testId }) => (
  <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} data-testid={testId} role="status"
    className={`border p-8 sm:p-10 ${dark ? "border-white/20 text-white" : "border-[#8EA3BC]/50 bg-white text-[#0F172A]"}`}>
    <CheckCircle2 className="h-10 w-10 text-[#C59B27]" aria-hidden="true" />
    <h3 className={`mt-5 font-serif text-2xl ${dark ? "text-white" : "text-[#1E3A5F]"}`}>{title}</h3>
    <p className={`mt-3 ${dark ? "text-[#C9D4E1]" : "text-[#4A5D75]"}`}>{body}</p>
    {refId && <p className={`mt-4 text-sm ${dark ? "text-[#C9D4E1]" : "text-[#4A5D75]"}`}>{refLabel}: <span dir="ltr" className="font-mono">{refId}</span></p>}
    <button type="button" onClick={onAgain} className="mt-6 text-sm font-semibold underline underline-offset-4" data-testid={`${testId}-again`}>{again}</button>
  </motion.div>
);
